import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Header from '../../components/Header';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router';

function IncorrectLink() {
  const { t } = useTranslation();

  return (
    <Container className="bo-mobile">
      <Header />
      <div className="bo-rounded-container mt-5 py-4">
        <Row className="mt-4 mb-2 mx-3">
          <Col className="text-center">
            <p className="bo-larger bo-extra-bold">{t('pages.incorrect_link.it_looks_like')}</p>
          </Col>
        </Row>
        <Row className="mx-3 mb-4">
          <Col className="text-center">
            <p className="bo-text">
              <Trans t={t} i18nKey="pages.incorrect_link.please_reach_out">
                Please reach out to the person who shared the link with you to get the correct one,
                or contact
                <Link className="bo-link" to="/signup/support">
                  Bridgeover support
                </Link>
                for assistance.
              </Trans>
            </p>
          </Col>
        </Row>
      </div>
    </Container>
  );
}

export default IncorrectLink;
